import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "card mb-25 border-0 rounded-0 bg-white add-besc-card shadow-sm" }
const _hoisted_3 = {
  key: 0,
  class: "alert alert-warning mb-4"
}
const _hoisted_4 = { class: "text-primary fw-semibold mb-3" }
const _hoisted_5 = { class: "corrections-list" }
const _hoisted_6 = { class: "flex-grow-1" }
const _hoisted_7 = { class: "fw-semibold" }
const _hoisted_8 = { class: "mb-0 small text-muted" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "card-body p-15 p-sm-20 p-md-30 letter-spacing" }
const _hoisted_11 = { class: "border border-primary rounded-3 shadow-sm overflow-hidden" }
const _hoisted_12 = {
  class: "row d-flex align-items-center justify-content-between fw-bold py-3 px-4 m-0",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_13 = { class: "col-md-5 text-end" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "p-4" }
const _hoisted_16 = { class: "col-md-5" }
const _hoisted_17 = { class: "col-md-5" }
const _hoisted_18 = ["onChange"]
const _hoisted_19 = {
  key: 0,
  class: "text-success d-block mt-2"
}
const _hoisted_20 = { class: "d-flex justify-content-between align-items-center mt-5 pt-4 border-top" }
const _hoisted_21 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.corrections.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h6", _hoisted_4, [
              _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1)),
              _createTextVNode(" Corrections demandées (" + _toDisplayString(_ctx.corrections.length) + ") ", 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.corrections, (correction) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: correction.id,
                  class: "d-flex align-items-center justify-content-between p-2 mb-2 bg-light rounded"
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("small", _hoisted_7, _toDisplayString(correction.fields_concerned), 1),
                    _createElementVNode("p", _hoisted_8, _toDisplayString(correction.message_to_requester), 1)
                  ]),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.markCorrectionAsFixed(correction.id)),
                    class: "btn btn-success btn-sm"
                  }, [...(_cache[3] || (_cache[3] = [
                    _createElementVNode("i", { class: "fas fa-check me-1" }, null, -1),
                    _createTextVNode(" Corrigé ", -1)
                  ]))], 8, _hoisted_9)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _cache[8] || (_cache[8] = _createElementVNode("div", {
        class: "card-header d-flex justify-content-between align-items-center py-4 px-4",
        style: {"background-color":"#0a59a4"}
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("h3", { class: "text-white fw-bold mb-1" }, "Étape 3/3 – Documents & Validation finale"),
          _createElementVNode("small", { class: "text-white opacity-75" }, "Téléversez les documents nécessaires et validez le BESC")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-md-7" }, [
              _createElementVNode("h5", { class: "text-white mb-0" }, "Pièce(s) jointe(s)")
            ], -1)),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-light btn-sm shadow-sm",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addPiece && _ctx.addPiece(...args))),
                disabled: !_ctx.canAddPiece
              }, " Ajouter une pièce ", 8, _hoisted_14)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "row gx-3 mb-3 fw-bold text-muted small" }, [
              _createElementVNode("div", { class: "col-md-5" }, "TYPE DE DOCUMENT"),
              _createElementVNode("div", { class: "col-md-5" }, "FICHIER")
            ], -1)),
            _cache[6] || (_cache[6] = _createElementVNode("hr", { class: "mt-0 mb-4" }, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pieces, (piece, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: piece.id ? 'doc-' + piece.id : piece._key,
                class: "row gx-3 align-items-center mb-3 pb-3 border-bottom"
              }, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_Multiselect, {
                    modelValue: piece.type,
                    "onUpdate:modelValue": ($event: any) => ((piece.type) = $event),
                    options: _ctx.typeDocuments,
                    label: "label",
                    "track-by": "value",
                    placeholder: "Sélectionner le type",
                    searchable: true,
                    "close-on-select": true,
                    "show-labels": false,
                    object: true
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("input", {
                    type: "file",
                    class: "form-control shadow-sm",
                    onChange: e => _ctx.handleFile(e, index)
                  }, null, 40, _hoisted_18),
                  (piece.filename)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_19, _toDisplayString(piece.filename), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_router_link, {
            to: { name: 'EditAddBescStep2', params: { id: _ctx.bescId } },
            class: "btn btn-danger px-4"
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode(" Retour à l'étape 2 ", -1)
            ]))]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToRecap && _ctx.goToRecap(...args))),
            class: "btn px-5 py-2 text-white",
            style: {"background-color":"#0a59a4","border":"none"},
            disabled: !_ctx.hasAllDocuments
          }, " Mettre à jour & Passez à l'étape 4 ", 8, _hoisted_21)
        ])
      ])
    ])
  ]))
}